<template>
  <v-container v-if="isSurveysEnabled" fluid class="pa-0">
    <survey-dlg v-if="isSurveyDlgRendered" :survey="userSurvey"></survey-dlg>
  </v-container>
</template>

<script>
import { logHelper } from '@/helpers/log-helper';
import { logger } from '@/helpers/log.service';
import { globalSettingsHelper } from '@/helpers/settings-helper';

import uiMixin from '@/mixins/ui-mixin';
import { AppError } from '@/models/log.models';
import { actions as _act } from '@/models/store.actions';

import { surveysService } from '@/services/survey.service';

import SurveyDlg from './SurveyDlg.vue';

export default {
  name: 'AppSurvey',
  components: { SurveyDlg },
  mixins: [uiMixin],
  data() {
    return {
      isSurveysEnabled: false,
      userAvailableSurveys: [],
      userSurvey: null
    };
  },
  computed: {
    isSurveyDlgRendered() { return this.isSurveysEnabled && this.userSurvey; },
    isLogined() { return this.$store.getters[_act.AUTH_GET_ISLOGINEDGET]; }
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.isSurveysEnabled = globalSettingsHelper.isSurveyEnabled;
      logger.debug(
        `[AppSurvey] isSurveysEnabled=${this.isSurveysEnabled}`
      );
      if (this.isSurveysEnabled) {
        this.subscribe();
        if (this.isLogined) {
          await this.loadSurveysAvailableForUser();
        }
      }
    },
    subscribe() {
      this.$eventBus.$on('user-logged', this.onUserLogged);
    },
    unsubscribe() {
      this.$eventBus.$off('user-logged', this.onUserLogged);
    },
    onUserLogged() {
      this.loadSurveysAvailableForUser();
    },
    async loadSurveysAvailableForUser() {
      const loader = this.showLoading();
      try {
        this.userAvailableSurveys = [];
        this.userSurvey = null;
        this.userAvailableSurveys = await surveysService.getActiveSurveys();
        logger.debug('[AppSurvey] userAvailableSurveys', this.userAvailableSurveys);
        if (this.userAvailableSurveys.length > 0) {
          this.userSurvey = this.userAvailableSurveys[0];
        }
      } catch (err) {
        if (!(err instanceof AppError)) { logHelper.error(err); }
      } finally {
        loader.hide();
      }
    }
  }
};
</script>
